module.exports = __webpack_public_path__ + "136a2f2517f02d25f83d526c088ce574.pdf";